const UserLocationTypes = {
  CareCenter: 260,
  HealthDept: 254,
  PrivateSchool: 258,
  PublicSchool: 257,
  HeadStart: 256,
  Home: 259,
  Institutions: 350,
  OtherAgencies: 261,
  Other: 263,
};
export default UserLocationTypes;
